<template>
  <a-drawer
      :title="title"
      placement="right"
      :footer="false"
      :visible="visible"
      width="600px"
      @close="onClose"
  >
    <a-form-model
        ref="LectureCrewRef"
        :model="form"
        :rules="rules">
      <a-form-model-item label="邀请内容" prop="InvitationContent">
        <a-textarea
            v-model="form.InvitationContent"
            placeholder="请输入"
            :auto-size="{ minRows: 10, maxRows: 15 }"
        />
      </a-form-model-item>
    </a-form-model>
    <div
        :style="{
          position: 'absolute',
          bottom: 0,
          width: '100%',
          borderTop: '1px solid #e8e8e8',
          padding: '10px 16px',
          textAlign: 'right',
          left: 0,
          background: '#fff',
          borderRadius: '0 0 4px 4px',
        }"
    >
      <a-button style="marginRight: 8px" @click="duplicateBtn" :disabled="form.InvitationContent ? false:true">
        复制内容
      </a-button>
<!--      <a-button type="primary" @click="addCrewSubmitLecture">-->
<!--        确认-->
<!--      </a-button>-->
    </div>
  </a-drawer>
</template>

<script>
import {invitationContent} from "@/service/participants";

export default {
name: "InviteModel",
  props:{
    title:{
      type:String
    },
    visible:{
      type:String
    },
    conventionCode:{
      type:String
    },
    conventionMemberId:{
      type:String
    },
  },
  data(){
    return{
      form:{
        InvitationContent:'',
      },
      rules:{
        InvitationContent: [{required: true, message: '请输入', trigger: 'blur'}],
      }
    }
  },
  created() {
  this.getInvitationContent();
  },
  methods:{
    //获取单个参会人员邀请内容
    async getInvitationContent() {
      const response = await invitationContent(this.conventionCode,this.conventionMemberId)
      if(response.code === 200){
        this.form.InvitationContent = response.data ? response.data : '';
      }
    },
    onClose(){
      let flag = false;
      this.$emit("closeMain", flag); //子组件向父组件传值（开关）
      this.form.InvitationContent = '';
    },
    //复制
    duplicateBtn(){
      if(this.form.InvitationContent){
        //创建input标签
        var input = document.createElement('input')
        //将input的值设置为需要复制的内容
        input.value = this.form.InvitationContent;
        //添加input标签
        document.body.appendChild(input)
        //选中input标签
        input.select()
        //执行复制
        document.execCommand('copy')
        //成功提示信息
        this.$message.success('文本已复制到剪贴板!')
        //移除input标签
        document.body.removeChild(input)
      }else {
        this.$message.warning("内容为空~")
      }

    }
  }
}
</script>

<style scoped>

</style>
